// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","noContent":"reviews-no-content_noContent__ZTmZj"};